export const commonRoutes = {
  GOOGLE_AUTH: {
    ROOT: '/auth/google',
  },
  LOGIN: {
    ROOT: '/login',
  },
  FORGOT_PASSWORD: {
    ROOT: '/forgot-password',
  },
  RESET_PASSWORD: {
    ROOT: '/reset-password',
  },
  LOGOUT: {
    ROOT: '/auth/logout',
  },
  APP: {
    ROOT: '/',
  },
  ERROR: {
    ROOT: '/error',
  },
} as const;
